<script setup lang="ts">
import { QTabs } from 'quasar'
import { PTabsAlign } from './types'

type Props = {
  vertical?: boolean
  scrollable?: boolean
  align?: PTabsAlign
}

withDefaults(defineProps<Props>(), {
  vertical: false,
  scrollable: false,
  align: PTabsAlign.JUSTIFY,
})

const model = defineModel<string | number | null>({ default: null })
</script>

<template>
  <q-tabs
    v-model="model"
    :vertical="vertical"
    class="p-tabs"
    :class="[{ 'p-tabs__scrollable': scrollable }]"
    :align="align"
    indicator-color="primary"
    active-color="primary"
    active-class="p-btn-active"
    content-class="p-tabs-content"
    left-icon="fa-light fa-chevron-left"
    right-icon="fa fa-light fa-chevron-right"
    mobile-arrows
    outside-arrows
  >
    <slot />
  </q-tabs>
</template>

<style lang="scss">
@import '../../assets/scss/shared/_brand.module.scss';

.p-tabs {
  // Arrows (start and end) in component QTabs (PTabs in DS)
  .q-tabs__arrow {
    background: getColor('white');
    color: getColor('primaryDark');
    font-size: 16px;

    &.q-tabs__arrow--left {
      box-shadow: 4px 0 6px -6px rgba(10, 10, 10, 0.5);
    }

    &.q-tabs__arrow--right {
      box-shadow: -4px 0 6px -6px rgba(10, 10, 10, 0.5);
    }
  }

  &__scrollable {
    .p-tabs-content {
      overflow: scroll;
    }
  }
}
</style>
